import { readCookie } from '../../../../components/common/Cookie';

interface CurrentUserProps {
  name: string;
  mobile: string;
  uuid: string;
}

export default function getCurrentUser(): CurrentUserProps {
  return {
    name: readCookie('SN') || '',
    mobile: readCookie('MN') || '',
    uuid: readCookie('UUID') || readCookie('uuid') || readCookie('CI') || ''
  };
}
